import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  DuplicateWritingModal,
  AddWritingModal,
  VerifyClosing,
  DeteteAccount,
  ModifyBudget,
  OpenBudget,
  CreateCategoryCheck,
  DeleteCategoryCheck,
  DndCheck,
  ModifySerie,
  DndHorizontalCheck,
  DndSpecialModal,
  AssignPlanComptaModal,
  AssignPlanComptaConfirmModal,
  EditSerieConfirmation,
  DeleteSerieConfirmation,
  DeleteConfirmation,
  LinkingModal,
  LinkingConfirmClose,
  LinkingDeleteConfirm,
  LinkingDeleteAllConfirm,
  LinkingDeactivateConfirm,
  TresorerieLockSuccess,
  TresorerieLockError,
  ResultatLockSuccess,
  ResultatLockError,
  DndRestriction,
  TresoUnlockConfirm,
  ResultatUnlockConfirm,
  ImportOFXModal,
  DeleteImportedCategoryModal,
  ExportTypeModal,
  ExportSynthesisResult,
  ExportSynthesisTreso,
  ExportWritingList,
  ExportWritingFilter,
  ExportMonthEndBilan,
  ShowPointedSumsModal,
  MonthEndBalanceSheetItemsModal,
  ProjectReadyActionsModal,
} from "../Modals";

import { closeModal } from "../../data/slices/modals";
import AddCompteModal from "../Modals/AddAccountModal";

const ModalsProvider = () => {
  const { modals } = useSelector((state) => state.modals);
  const dispatch = useDispatch();

  const modalState = (id, key) => {
    const res = modals.find((modal) => modal.id === id);
    return res[key];
  };

  const handleClose = (id) => {
    dispatch(closeModal(id));
  };

  return (
    <>
      <AddWritingModal
        id="add-writing-expression"
        open={modalState("add-writing-expression", "open")}
        data={modalState("add-writing-expression", "data")}
        handleClose={handleClose}
      />
      <VerifyClosing
        id="verify-closing-modal"
        open={modalState("verify-closing-modal", "open")}
        data={modalState("verify-closing-modal", "data")}
      />
      <DuplicateWritingModal
        id="duplicate-writing-modal"
        open={modalState("duplicate-writing-modal", "open")}
        data={modalState("duplicate-writing-modal", "data")}
        handleClose={handleClose}
      />
      <AddCompteModal
        id="create-compte-modal"
        open={modalState("create-compte-modal", "open")}
        data={modalState("create-compte-modal", "data")}
        handleClose={handleClose}
      />
      <DeteteAccount
        id="delete-compte-modal"
        open={modalState("delete-compte-modal", "open")}
        data={modalState("delete-compte-modal", "data")}
        handleClose={handleClose}
      />
      <ModifyBudget
        id="modify-budget-modal"
        open={modalState("modify-budget-modal", "open")}
        data={modalState("modify-budget-modal", "data")}
        handleClose={handleClose}
      />
      <OpenBudget
        id="open-budget-modal"
        open={modalState("open-budget-modal", "open")}
        data={modalState("open-budget-modal", "data")}
        handleClose={handleClose}
      />
      <CreateCategoryCheck
        id="create-category-check-modal"
        open={modalState("create-category-check-modal", "open")}
        data={modalState("create-category-check-modal", "data")}
        handleClose={handleClose}
      />
      <AssignPlanComptaModal
        id="assign-plan-compta-modal"
        open={modalState("assign-plan-compta-modal", "open")}
        data={modalState("assign-plan-compta-modal", "data")}
        handleClose={handleClose}
      />
      <AssignPlanComptaConfirmModal
        id="assign-plan-compta-confirm-modal"
        open={modalState("assign-plan-compta-confirm-modal", "open")}
        data={modalState("assign-plan-compta-confirm-modal", "data")}
        handleClose={handleClose}
      />
      <DeleteCategoryCheck
        id="delete-category-check-modal"
        open={modalState("delete-category-check-modal", "open")}
        data={modalState("delete-category-check-modal", "data")}
        handleClose={handleClose}
      />
      <DndCheck
        id="dnd-category-check-modal"
        open={modalState("dnd-category-check-modal", "open")}
        data={modalState("dnd-category-check-modal", "data")}
        handleClose={handleClose}
      />
      <ModifySerie
        id="modify-serie"
        open={modalState("modify-serie", "open")}
        data={modalState("modify-serie", "data")}
        handleClose={handleClose}
      />
      <DndHorizontalCheck
        id="dnd-horizontal-check-modal"
        open={modalState("dnd-horizontal-check-modal", "open")}
        data={modalState("dnd-horizontal-check-modal", "data")}
        handleClose={handleClose}
      />
      <DndSpecialModal
        id="dnd-special-modal"
        open={modalState("dnd-special-modal", "open")}
        data={modalState("dnd-special-modal", "data")}
        handleClose={handleClose}
      />
      {modalState("edit-serie-confirmation-modal", "open") && (
        <EditSerieConfirmation
          id="edit-serie-confirmation-modal"
          open={modalState("edit-serie-confirmation-modal", "open")}
          data={modalState("edit-serie-confirmation-modal", "data")}
          type={
            modalState("edit-serie-confirmation-modal", "data")?.duplicationType
          }
          onCancel={
            modalState("edit-serie-confirmation-modal", "data")?.onCancel ||
            (() => handleClose("edit-serie-confirmation-modal"))
          }
          onConfirm={
            modalState("edit-serie-confirmation-modal", "data")?.onConfirm
          }
        />
      )}
      {modalState("delete-serie-confirmation-modal", "open") && (
        <DeleteSerieConfirmation
          id="delete-serie-confirmation-modal"
          open={modalState("delete-serie-confirmation-modal", "open")}
          data={modalState("delete-serie-confirmation-modal", "data")}
          type={
            modalState("delete-serie-confirmation-modal", "data")
              ?.duplicationType
          }
          onCancel={
            modalState("delete-serie-confirmation-modal", "data")?.onCancel ||
            (() => handleClose("delete-serie-confirmation-modal"))
          }
          onConfirm={
            modalState("delete-serie-confirmation-modal", "data")?.onConfirm
          }
        />
      )}
      {modalState("edit-duplicated-element-confirmation-modal", "open") && (
        <EditSerieConfirmation
          id="edit-duplicated-element-confirmation-modal"
          open={modalState(
            "edit-duplicated-element-confirmation-modal",
            "open"
          )}
          data={modalState(
            "edit-duplicated-element-confirmation-modal",
            "data"
          )}
          type={
            modalState("edit-duplicated-element-confirmation-modal", "data")
              ?.duplicationType
          }
          onCancel={
            modalState("edit-duplicated-element-confirmation-modal", "data")
              ?.onCancel ||
            (() => handleClose("edit-duplicated-element-confirmation-modal"))
          }
          onConfirm={
            modalState("edit-duplicated-element-confirmation-modal", "data")
              ?.onConfirm
          }
        />
      )}
      {modalState("delete-duplicated-element-confirmation-modal", "open") && (
        <DeleteSerieConfirmation
          id="delete-duplicated-element-confirmation-modal"
          open={modalState(
            "delete-duplicated-element-confirmation-modal",
            "open"
          )}
          data={modalState(
            "delete-duplicated-element-confirmation-modal",
            "data"
          )}
          type={
            modalState("delete-duplicated-element-confirmation-modal", "data")
              ?.duplicationType
          }
          onCancel={
            modalState("delete-duplicated-element-confirmation-modal", "data")
              ?.onCancel ||
            (() => handleClose("delete-duplicated-element-confirmation-modal"))
          }
          onConfirm={
            modalState("delete-duplicated-element-confirmation-modal", "data")
              ?.onConfirm
          }
        />
      )}
      {modalState("delete-confirmation-modal", "open") && (
        <DeleteConfirmation
          id="delete-confirmation-modal"
          open={modalState("delete-confirmation-modal", "open")}
          data={modalState("delete-confirmation-modal", "data")}
          nameToDelete={
            modalState("delete-confirmation-modal", "data")?.nameToDelete
          }
          isElement={modalState("delete-confirmation-modal", "data")?.isElement}
          isPlancompta={
            modalState("delete-confirmation-modal", "data")?.isPlancompta
          }
          onCancel={
            modalState("delete-confirmation-modal", "data")?.onCancel ||
            (() => handleClose("delete-confirmation-modal"))
          }
          onConfirm={modalState("delete-confirmation-modal", "data")?.onConfirm}
        />
      )}

      <LinkingModal
        id="linking-modal"
        open={modalState("linking-modal", "open")}
        data={modalState("linking-modal", "data")}
        handleClose={handleClose}
      />

      <LinkingConfirmClose
        id="linking-confirm-close-modal"
        open={modalState("linking-confirm-close-modal", "open")}
        data={modalState("linking-confirm-close-modal", "data")}
        handleClose={handleClose}
      />

      <LinkingDeleteConfirm
        id="linking-delete-confirm-modal"
        open={modalState("linking-delete-confirm-modal", "open")}
        data={modalState("linking-delete-confirm-modal", "data")}
        handleClose={handleClose}
      />

      <LinkingDeleteAllConfirm
        id="linking-delete-all-confirm-modal"
        open={modalState("linking-delete-all-confirm-modal", "open")}
        data={modalState("linking-delete-all-confirm-modal", "data")}
        handleClose={handleClose}
      />

      <LinkingDeactivateConfirm
        open={modalState("linking-deactivate-confirm-modal", "open")}
        onConfirm={
          modalState("linking-deactivate-confirm-modal", "data")?.onConfirm
        }
        onCancel={() => handleClose("linking-deactivate-confirm-modal")}
      />

      <TresorerieLockSuccess
        open={modalState("tresorerie-lock-success-modal", "open")}
        onConfirm={
          modalState("tresorerie-lock-success-modal", "data")?.onConfirm
        }
        onCancel={() => handleClose("tresorerie-lock-success-modal")}
      />

      <TresorerieLockError
        open={modalState("tresorerie-lock-error-modal", "open")}
        onCancel={() => handleClose("tresorerie-lock-error-modal")}
      />

      <ResultatLockSuccess
        open={modalState("resultat-lock-success-modal", "open")}
        onConfirm={modalState("resultat-lock-success-modal", "data")?.onConfirm}
        onCancel={() => handleClose("resultat-lock-success-modal")}
      />

      <ResultatLockError
        open={modalState("resultat-lock-error-modal", "open")}
        onCancel={() => handleClose("resultat-lock-error-modal")}
      />

      <DndRestriction
        open={modalState("dnd-restriction-modal", "open")}
        onCancel={() => handleClose("dnd-restriction-modal")}
      />

      <TresoUnlockConfirm
        open={modalState("treso-unlock-confirm-modal", "open")}
        onConfirm={modalState("treso-unlock-confirm-modal", "data")?.onConfirm}
        onCancel={() => handleClose("treso-unlock-confirm-modal")}
      />

      <ResultatUnlockConfirm
        open={modalState("resultat-unlock-confirm-modal", "open")}
        onConfirm={
          modalState("resultat-unlock-confirm-modal", "data")?.onConfirm
        }
        onCancel={() => handleClose("resultat-unlock-confirm-modal")}
      />

      <ImportOFXModal
        open={modalState("import-ofx-modal", "open")}
        onCancel={() => handleClose("import-ofx-modal")}
        data={modalState("import-ofx-modal", "data")}
      />

      <DeleteImportedCategoryModal
        open={modalState("delete-imported-category-modal", "open")}
        onCancel={() => handleClose("delete-imported-category-modal")}
        data={modalState("delete-imported-category-modal", "data")}
      />
      <ExportTypeModal
        open={modalState("export-type-modal", "open")}
        onCancel={() => handleClose("export-type-modal")}
        data={modalState("export-type-modal", "data")}
      />
      <ExportSynthesisResult
        open={modalState("export-synthesis-result-modal", "open")}
        onCancel={() => handleClose("export-synthesis-result-modal")}
        data={modalState("export-synthesis-result-modal", "data")}
      />
      <ExportSynthesisTreso
        open={modalState("export-synthesis-treso-modal", "open")}
        onCancel={() => handleClose("export-synthesis-treso-modal")}
        data={modalState("export-synthesis-treso-modal", "data")}
      />
      <ExportWritingList
        open={modalState("export-writing-list-modal", "open")}
        onCancel={() => handleClose("export-writing-list-modal")}
        data={modalState("export-writing-list-modal", "data")}
      />
      <ExportWritingFilter
        open={modalState("export-writing-filter-modal", "open")}
        onCancel={() => handleClose("export-writing-filter-modal")}
        data={modalState("export-writing-filter-modal", "data")}
      />
      <ExportMonthEndBilan
        open={modalState("export-month-end-bilan-modal", "open")}
        onCancel={() => handleClose("export-month-end-bilan-modal")}
        data={modalState("export-month-end-bilan-modal", "data")}
      />
      <ShowPointedSumsModal
        open={modalState("show-pointed-sums-modal", "open")}
        onCancel={() => handleClose("show-pointed-sums-modal")}
        data={modalState("show-pointed-sums-modal", "data")}
      />

      <MonthEndBalanceSheetItemsModal
        open={modalState("month-end-balance-sheet-items-modal", "open")}
        onCancel={() => handleClose("month-end-balance-sheet-items-modal")}
        data={modalState("month-end-balance-sheet-items-modal", "data")}
      />

      <ProjectReadyActionsModal
        open={modalState("project-ready-actions-modal", "open")}
        onCancel={() => handleClose("project-ready-actions-modal")}
        data={modalState("project-ready-actions-modal", "data")}
      />
    </>
  );
};

export default ModalsProvider;
